import React from 'react';
import { X } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';

const HelpModal: React.FC = () => {
    const { isHelpOpen, setHelpOpen } = useAppContext();

    if (!isHelpOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setHelpOpen(false)}>
            <div className="bg-card rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center p-4 border-b border-border">
                    <h2 className="text-xl font-bold">Application Help</h2>
                    <button onClick={() => setHelpOpen(false)} className="p-2 rounded-full hover:bg-background">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6 space-y-4 text-text-secondary">
                    <div>
                        <h4 className="font-semibold text-text-primary">Modes</h4>
                        <p>Use the &apos;Mode&apos; switcher in the header to switch between Simple and Advanced. Advanced mode enables Graph View, Traceability, BOM Functions, DVP&amp;R, and the full-screen FMEA Editor.</p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-text-primary">P-Diagram</h4>
                        <p>Use the dropdown to switch between the 12 Master Functions. Click items to see connected risks, controls, and tests.</p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-text-primary">FMEAs</h4>
                        <p>The main table shows the full dataset. Use the function filter to narrow the results. Click the &apos;Open FMEA Editor&apos; button in the header (Advanced mode) to edit data and import/export CSV files.</p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-text-primary">Risk Analysis</h4>
                        <p>Two matrices (S×O and S×D). Click circles (ranked by RPN) to jump to the corresponding FMEA risk.</p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-text-primary">Traceability & Graph View (Advanced)</h4>
                        <p>These sections provide interactive cross-referencing. The graph layout can be toggled between Grid and Force. In Force mode, clicking any node re-centers the layout around it. Ctrl/Cmd-clicking a node navigates to its detail page.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpModal;
